module.exports = __webpack_public_path__ + "static/img/rule_top.7eb24031.png";